import { ArrayExt } from '@lumino/algorithm';
import { UUID } from '@lumino/coreutils';
/**
 * A class to handle requests to /api/sessions
 */
export class Sessions {
    /**
     * Construct a new Sessions.
     *
     * @param options The instantiation options for a Sessions.
     */
    constructor(options) {
        // TODO: offload to a database
        this._sessions = [];
        this._kernels = options.kernels;
    }
    /**
     * Get a session by id.
     *
     * @param id The id of the session.
     */
    async get(id) {
        const session = this._sessions.find(s => s.id === id);
        if (!session) {
            throw Error(`Session ${id} not found`);
        }
        return session;
    }
    /**
     * List the running sessions
     */
    async list() {
        return this._sessions;
    }
    /**
     * Path an existing session.
     * This can be used to rename a session.
     * TODO: read path and name
     *
     * @param options The options to patch the session.
     */
    async patch(options) {
        const { id, path, name } = options;
        const index = this._sessions.findIndex(s => s.id === id);
        const session = this._sessions[index];
        if (!session) {
            throw Error(`Session ${id} not found`);
        }
        const patched = {
            ...session,
            path: path !== null && path !== void 0 ? path : session.path,
            name: name !== null && name !== void 0 ? name : session.name
        };
        this._sessions[index] = patched;
        return patched;
    }
    /**
     * Start a new session
     * TODO: read path and name
     *
     * @param options The options to start a new session.
     */
    async startNew(options) {
        var _a, _b, _c;
        const { path, name } = options;
        const running = this._sessions.find(s => s.name === name);
        if (running) {
            return running;
        }
        const kernelName = (_b = (_a = options.kernel) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
        const id = (_c = options.id) !== null && _c !== void 0 ? _c : UUID.uuid4();
        const kernel = await this._kernels.startNew({ id, name: kernelName });
        const session = {
            id,
            path,
            name: name !== null && name !== void 0 ? name : path,
            type: 'notebook',
            kernel: {
                id: kernel.id,
                name: kernel.name
            }
        };
        this._sessions.push(session);
        return session;
    }
    /**
     * Shut down a session.
     *
     * @param id The id of the session to shut down.
     */
    async shutdown(id) {
        var _a;
        const session = this._sessions.find(s => s.id === id);
        if (!session) {
            throw Error(`Session ${id} not found`);
        }
        const kernelId = (_a = session.kernel) === null || _a === void 0 ? void 0 : _a.id;
        if (kernelId) {
            await this._kernels.shutdown(kernelId);
        }
        ArrayExt.removeFirstOf(this._sessions, session);
    }
}
